import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { posthog } from 'posthog-js';
import { selectGlobalSettings } from '../globalSettings/globalSettingsSlice';
import AIAssistantDialog from './ai-assistant/AIAssistantDialog';
import SupportFormDialog from './support-form/SupportFormDialog';
import { GlobalDialogProps } from '../../types';
import { RootState } from '../../reducers';

interface ContactSupportDialogProps extends GlobalDialogProps {
  formSource?: string;
}

const ContactSupportDialog: React.FC<ContactSupportDialogProps> = ({
  onClose,
  formSource = 'Contact Support Dialog',
}) => {
  const globalSettings = useSelector((state: RootState) =>
    selectGlobalSettings(state)
  );

  // Track contact support dialog open
  useEffect(() => {
    posthog.capture('contact-support-dialog-opened', {
      form_source: formSource,
      ai_chat_enabled: globalSettings?.aiChatEnabled || false,
    });
  }, [formSource, globalSettings?.aiChatEnabled]);

  // Show loading state while fetching settings
  // if (loading) {
  //   return (
  //     <div
  //       style={{
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         minHeight: '300px',
  //         fontSize: '16px',
  //         color: '#666',
  //       }}
  //     >
  //       Loading support options...
  //     </div>
  //   );
  // }

  // Show AI Assistant if globally enabled, otherwise show traditional form
  if (globalSettings?.aiChatEnabled) {
    return <AIAssistantDialog onClose={onClose} formSource={formSource} />;
  }

  return <SupportFormDialog onClose={onClose} formSource={formSource} />;
};

export default ContactSupportDialog;
